/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { COMPONENT_NAME_PREFIX } from '../constants';
const elementName = `${COMPONENT_NAME_PREFIX}skip-link`;
const observedAttributes = {
    TARGET: 'target',
    THEME: 'theme',
    MUTED: 'muted',
    PERSISTENT: 'persistent',
    INLINE: 'inline',
    SKIP_URL_CHANGE: 'skip-url-change'
};
const attributes = {
    ...observedAttributes
};
const selectors = {
    ANCHOR: 'a'
};
export const SKIP_LINK_CONSTANTS = {
    elementName,
    observedAttributes,
    attributes,
    selectors
};
